import { connect } from 'react-redux'
import Work from './work'
import { fetchWorks } from '../../../../stores/works/works.actions'
import { withRouter } from 'react-router-dom'
import { getFetchRequest } from '../../../../stores/works/works.selectors'

const mapsStateToProps = state => {
  const fetchRequest = getFetchRequest(state)
  return {
    pending:
      (!fetchRequest.params || !fetchRequest.params.page) &&
      fetchRequest.pending
  }
}

const mapDispatchToProps = (dispatch, { match }) => ({
  onMount: () => dispatch(fetchWorks(match.params.id))
})

export default withRouter(
  connect(
    mapsStateToProps,
    mapDispatchToProps
  )(Work)
)
